import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './delete-life-area.style';

export type DeleteLifeAreaMessageProps = {
  name: string;
  onSubmit: () => void;
  onCancel: () => void;
};

export const DeleteLifeAreaMessage: React.FC<DeleteLifeAreaMessageProps> = ({
  name,
  onSubmit,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Styled.Header>
        <Typography variant="h5" component="h1">
          {t('forms.delete-life-area.message.title')}
        </Typography>
      </Styled.Header>

      <Styled.Body>
        <Typography variant="body2">
          {t('forms.delete-life-area.message.description.1')}
          <Styled.LifeAreaName>{name}</Styled.LifeAreaName>
          {t('forms.delete-life-area.message.description.2')}
        </Typography>
      </Styled.Body>

      <Styled.Interactions>
        <Button
          variant={Variants.Outlined}
          size={Sizes.Medium}
          onClick={onCancel}
        >
          {t('forms.delete-life-area.message.buttons.cancel.label')}
        </Button>
        <Button size={Sizes.Medium} color={Colors.Error} onClick={onSubmit}>
          {t('forms.delete-life-area.message.buttons.submit.label')}
        </Button>
      </Styled.Interactions>
    </>
  );
};
